import React, { Component } from "react";

import {
  getItemPresentation,
  getItemMeatPresentation,
  groupItemsByStation,
  groupItemsByStationWithoutZeroQty,
} from '../../utils/Helpers';


const tableStyle = {
  border: "1px solid gray",
  width: "100%",
  textAlign: "center",
  borderCollapse: "collapse",
};

const tableBreakStyle = {
  border: "1px solid gray",
  width: "100%",
  textAlign: "center",
  borderCollapse: "collapse",
  pageBreakAfter: 'always'
};

const stationRow = {
  border: "1px solid gray",
  textAlign: 'left',
  background: '#e9ebec',
}

const rowBorder = {
  border: "1px solid gray",
};


const empty_line = {
  marginTop: "10mm",
};

const alignLeft = {
  textAlign: "left"
}

const OrderHeader = ({ order, orderDate, deliveryDate }) => (
  <table style={tableStyle}>
    <tbody>
      <tr>
        <td style={{border: "1px solid gray", width: '30%'}}><b>Order </b> #{order.id}</td>
        <td style={{border: "1px solid gray", width: '70%'}} colSpan="2"><b>Market: </b> {order.market}</td>
      </tr>
      <tr>
        <td style={{border: "1px solid gray", width: '30%'}}><b>User: </b> {order.created_by}</td>
        <td style={{border: "1px solid gray", width: '35%'}}><b>Date: </b> {orderDate}</td>
        <td style={{border: "1px solid gray", width: '35%'}}><b>Delivery Date: </b> {deliveryDate}</td>
      </tr>
    </tbody>
  </table>
);

const OrderBody = ({ station, items, showItemsWithZeroQty }) => (
  <tbody>
    <tr>
      <td colSpan="5" style={stationRow} >
        <b style={{marginLeft: '3mm'}}>
          {station}
        </b>
      </td>
    </tr>
    {items.map((item) => {
      const presentation = getItemPresentation(item.item);
      const showItem = showItemsWithZeroQty || item.amount !== 0;
      return (
        showItem && (
          <tr key={item.id}>
            <td style={{ ...rowBorder, ...alignLeft }}>
              {item.name} {item.grade !== null ? `(Grade: ${item.grade})` : ""}
            </td>
            <td style={rowBorder}>{item.inventory ? item.inventory : "-"}</td>
            <td style={rowBorder}>{item.previous_ordered ? item.previous_ordered : "-"}</td>
            <td style={rowBorder}>{presentation ? presentation : getItemMeatPresentation(item.item, item.presentation)}</td>
            <td style={rowBorder}>{item.amount}</td>
          </tr>
        )
      );
    })}
  </tbody>
)


export default class MarketPrintOrder extends Component {
  render() {
    const { order, orderDate, deliveryDate, showItemsWithZeroQty } = this.props;
    const itemsByStation = order.status !== 2 ? groupItemsByStation(order.items) : groupItemsByStationWithoutZeroQty(order.items);
    return (
      <div className="orderPrint text-center" id="marketOrderPrintContent">
        <OrderHeader order={order} orderDate={orderDate} deliveryDate={deliveryDate} />
        <div style={empty_line}></div>
        {Object.keys(itemsByStation).map((station) => (
          <table style={tableBreakStyle}>
            <thead>
              <tr>
                <td><b>Item</b></td>
                <td style={{...rowBorder, width: "72px"}}><b>Inventory</b></td>
                <td style={{...rowBorder, width: "120px"}}><b>Previous ordered</b></td>
                <td style={{...rowBorder, width: "100px"}}><b>Presentation</b></td>
                <td style={{...rowBorder, width: "55px"}}><b>Qty</b></td>
              </tr>
            </thead>
            <OrderBody
              key={station}
              station={station}
              items={itemsByStation[station]}
              showItemsWithZeroQty={showItemsWithZeroQty}
            />
          </table>
        ))}
      </div>
    );
  }
}
